import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { P } from '../../../AbstractElements';
import { useNavigate } from 'react-router-dom';

interface DraftPatientModalProps {
  modal: boolean
  setModal: (isModal: boolean) => void;
  patientId: string
}

const DraftPatientModal: React.FC<DraftPatientModalProps> = ({ modal, setModal, patientId }) => {
  const toggle = () => setModal(!modal);
  const navigate = useNavigate()

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} size="sm" centered={true}>
        <ModalHeader toggle={toggle}>Edit Patient</ModalHeader>
        <ModalBody>
          <div>
            <P>There is an unsaved report for this patient.<br /><br /> Would you like to continue?</P>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => {
            navigate(`/patient/report_generate?patient_id=${patientId}`)
          }}>
            Continue
          </Button>{' '}
          <Button color="danger" onClick={() => {
            localStorage.removeItem("draftContent")
            localStorage.removeItem("draftPatient")
            localStorage.removeItem("draftType")
            localStorage.removeItem("rewriteStatus")
            navigate(`/patient/report_generate?patient_id=${patientId}`)
          }}>
            New
          </Button>
        </ModalFooter>

      </Modal>
    </div>
  );
}

export default DraftPatientModal;